import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachmentComponent } from './attachment.component';
import { FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LoadingOverlayModule } from '../loading-overlay/loading-overlay.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LightboxModule } from 'ng-gallery/lightbox';

@NgModule({
  imports: [CommonModule, FlexModule, MatIconModule, MatButtonModule, LoadingOverlayModule, MatTooltipModule, LightboxModule],
  declarations: [AttachmentComponent],
  exports: [AttachmentComponent]
})

export class AttachmentModule {
}
